// Helper function to get environment variables with fallback
const getEnvVar = (key: string, fallback: string = ""): string => {
  return import.meta.env[key] ?? fallback;
};

// Helper function to get required environment variables (throws if missing)
const getRequiredEnvVar = (key: string): string => {
  const value = import.meta.env[key];
  if (value === undefined || value === null || value === "") {
    console.warn("Warning: Required environment variable is not set");
    return "";
  }
  return value;
};

// For critical environment variables, use getRequiredEnvVar
export const environment: string = getRequiredEnvVar("VITE_ENVIRONMENT");
export const surveyBaseURL: string = getRequiredEnvVar(
  "VITE_SURVEY_SERVICE_BASE_URL",
);
export const userBaseURL: string = getRequiredEnvVar(
  "VITE_USER_SERVICE_BASE_URL",
);

// For optional environment variables, use getEnvVar with sensible defaults
export const mediaBaseURL: string = getEnvVar("VITE_MEDIA_SERVICE_BASE_URL");
export const siqBaseUrl: string = getEnvVar("VITE_SIQ_BASE_URL");
export const BAMmapAPI: string = getEnvVar("VITE_BAM_API");
export const BAMWSO2Token: string = getEnvVar("VITE_WSO2_BAM_TOKEN");
export const BAMWS02API: string = getEnvVar("VITE_WSO2_BAM_API");
export const appRootURL: string = getEnvVar("VITE_APP_ROOT_URL");
export const BAMWSO2ClientID: string = getEnvVar("VITE_WSO2_CLIENT_ID");
export const BAMWSO2SecretID: string = getEnvVar("VITE_WSO2_SECRET_ID");
export const EnvironmentType: string = getEnvVar(
  "VITE_ENVIRONMENT_TYPE",
  "development",
);
export const interactiveSurveyCoverDefaultImg: string = getEnvVar(
  "VITE_INTERACTIVE_SURVEY_DEFAULT_COVER_IMAGE",
);
export const interactiveSurveyOrigins: string = getEnvVar(
  "VITE_INTERACTIVE_SURVEY_ORIGINS",
);
export const defaultSupportEmail: string = getEnvVar(
  "VITE_DEFAULT_SUPPORT_EMAIL",
  "support@example.com",
);
export const bingKey: string = getEnvVar("VITE_BING_KEY");
export const mapBaseURL: string = getEnvVar("VITE_MEDIA_BASE_URL");
export const defaultUrlSegment: string = "/interactive";
export const defaultSections: { key: string; label: string; path: string }[] = [
  { key: "cover", label: "Overview", path: "cover" },
  { key: "market map", label: "Market Map", path: "marketmap" },
  {
    key: "property comparison",
    label: "Property Comparison",
    path: "comparison",
  },
  { key: "properties", label: "Properties", path: "property" },
  { key: "tour schedule", label: "Tour Schedule", path: "tour" },
];
